export default __webpack_public_path__ + "static/media/times-success.824fece1.svg";